import React, { useState } from 'react';
import PageLayout from '../components/PageLayout';
import { Typography, Box, Container } from '@mui/material';
import TipsHeader from '../components/cleaning-tips/TipsHeader';
import CategoryNavigation from '../components/cleaning-tips/CategoryNavigation';
import KitchenTips from '../components/cleaning-tips/KitchenTips';
import BathroomTips from '../components/cleaning-tips/BathroomTips';
import LivingRoomTips from '../components/cleaning-tips/LivingRoomTips';
import BedroomTips from '../components/cleaning-tips/BedroomTips';
import SeasonalTips from '../components/cleaning-tips/SeasonalTips';
import ProductTips from '../components/cleaning-tips/ProductTips';
import FeaturedTips from '../components/cleaning-tips/FeaturedTips';
import TipsGrid from '../components/cleaning-tips/TipsGrid';
import SeasonalGuides from '../components/cleaning-tips/SeasonalGuides';
import ShortTermRentalGuides from '../components/cleaning-tips/ShortTermRentalGuides';
import SectionBlock from '../components/SectionBlock';
import Seo from '../components/Seo';

const CleaningTipsPage = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  return (
    <PageLayout>
      <Seo
        title="Cleaning Tips & Home Care Guides"
        description="Practical cleaning tips from professional cleaners: kitchen, bathroom, bedroom and seasonal guides, plus product recommendations for a spotless home."
        path="/cleaning-tips"
      />
      <SectionBlock sx={{ 
        py: 8,
        backgroundImage: 'url(/images/quotation-hero.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: 'common.white'
      }}>
        <TipsHeader />
      </SectionBlock>
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <CategoryNavigation onSelectCategory={setSelectedCategory} />
        {selectedCategory === 'Kitchen' && <KitchenTips />}
        {selectedCategory === 'Bathroom' && <BathroomTips />}
        {selectedCategory === 'Living Room' && <LivingRoomTips />}
        {selectedCategory === 'Bedroom' && <BedroomTips />}
        {selectedCategory === 'Seasonal' && <SeasonalTips />}
        {selectedCategory === 'Products' && <ProductTips />}
        <FeaturedTips />
        <TipsGrid />
        <ShortTermRentalGuides />
        <SeasonalGuides />
      </Container>
    </PageLayout>
  );
};

export default CleaningTipsPage;

